import GPortalUIkit from '@gportal/uikit';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(GPortalUIkit);
});
